<template>
  <va-show :item="item">
    <va-field source="longitude" />
    <va-field source="latitude" />
    <va-field source="name" />
    <va-field source="address" />
  </va-show>
</template>

<script>
export default {
  props: ["item"],
};
</script>
